export const event18=[
 
  

  {
    "title": "PR TO THE LATERAL ENTRIES (2022 PASSING BATCH)",
    "date":"22 July 2019",
    "for": "Lateral Entry students (class of 2018-2022)",
    "description": "The lateral entry students with their entire class of 2018-2022 batch, from Information Technology Department were introduced to the ACM as a student chapter and how would one benefit as a member of ACM. It was an hour long interactive session and the response from the students was really positive and overwhelming.",
    "imgPaths":  ["image19_6.jpg"]
  },
  {
    "title": "ACM SOLUTION CONTEST",
    "date": "18 March 2019",
    "for": "All Students",
    "description":"The solution contest of ACM India is a way to engage all the chapters into competitive and collaborative participation and contribute to a social cause. The team ACM of VNRVJIET has also participated in this challenge by presenting an abstract to deal with agricultural problems in India. The main focus was on crop wastage and how it could be reduced using the modern technologies available.",
    "imgPaths": ["image19_7.jpg"]
  },
  {
    "title": "INTERACTION SESSION BY 4TH YEARS",
    "date":"22 February 2019",
    "for": "2nd and 3rd year IT students",
    "description":"An interaction was organized by ACM VNRVJIET between 4th years and upcoming 2nd and 3rd year IT students. Students who were placed in top companies like Microsoft, EA Sports, TSC etc came to interact with juniors. Notes on how to improve coding skills, points on internships and academics. It was a complete one hour session. ACM has conducted the first ever student friendly interactive session with the help of a few final years and the alumni. The seniors have talked about what all they learned in these past few years as a B.Tech student, their struggles, achievements, mistakes and basically life at VNR and after. All the doubts, misconceptions, advices and facts were discussed during the last 20min of this one hour fully packed interactive session.",
    "imgPaths": ["image19_8.jpg"]
  },
  {
    "title": "REPUBLIC DAY CELEBRATIONS",
    "date": "26 January 2019",
    "for": "All Students",
    "description":"When the whole country was celebrating the republic day, here at VNR we were also celebrating the newly formed ACM. It was the first time our student chapter participated in the salute parade.In Salute parade every student chapter and all the clubs of VNR come up with a theme and parade for its cause. ACM has come up with the theme 'History of technological advancements'. We projected the topics like communication in army, army weapons advancements, railway development, irrigation projects and their usage, cyber security and many more.",
    "imgPaths": ["image19_1.jpg"]
  },
  
  {
    "title": "HOURS OF CODE",
    "date":"23 January 2019",
    "for": "2nd year IT students",
    "description":"Hours of code, a coding event on HackerRank was conducted to understand and know more about their knowledge and expertise on the languages. To make the students loosen up a bit, a fun on-desk creative presentation and a small aptitude test was conducted. The actual contest consisted of four problem solving questions which were to be solved in either C/C++. The contest was about 80 minutes and after it ended all the doubts and solutions were discussed.",
    "imgPaths": ["image19_9.jpg"]
  },
  {
    "title": "PR FOR SECOND YEARS",
    "date": "20 January 2019",
    "for": "2nd year IT students",
    "description": "An interactive PR session to inform second-year students about the benefits of being part of ACM and how it helps in advancing knowledge on upcoming technologies.",
    "imgPaths": ["image19_2.jpg"]
  },
 {
    "title": "ACM VNRVJIET INAUGURAL CEREMONY",
    "date": "24 October 2018",
    "for": "All Students",
    "description": "VNR VJIET organized the inaugural ceremony for ACM, the 5th institution in Telangana authorized to run the ACM student chapter, with Dr. Ponnurangam Kumaraguru as the chief guest.",
    "imgPaths": ['image19_3.jpeg']
  },]